// import React, { useEffect, useState } from "react";
// import {
//   Table, TableBody, TableCell, TableHead, TableRow,
//   Typography, CircularProgress, Box, Paper, TableContainer,
//   Button, Tooltip, IconButton, Snackbar, Alert, Chip,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import BlockIcon from "@mui/icons-material/Block";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// import { getAllVendors, deactivateVendor, reactivateVendor } from "../../services/api";
// import VendorDialog from "../../components/VendorDialog";

// const VendorRecords = () => {
//   const [vendors, setVendors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [editingVendor, setEditingVendor] = useState(null);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const fetchVendors = () => {
//     setLoading(true);
//     getAllVendors()
//       .then((res) => {
//         setVendors(res.data.data || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch vendors:", err);
//         setLoading(false);
//         setSnackbar({
//           open: true,
//           message: "Failed to fetch vendors",
//           severity: "error",
//         });
//       });
//   };

//   useEffect(() => {
//     fetchVendors();
//   }, []);

//   const openCreateDialog = () => {
//     setEditingVendor(null);
//     setDialogOpen(true);
//   };

//   const openEditDialog = (vendor) => {
//     setEditingVendor(vendor);
//     setDialogOpen(true);
//   };

//   const handleDialogClose = () => {
//     setDialogOpen(false);
//     setEditingVendor(null);
//   };

//   const handleVendorSaved = (message) => {
//     setSnackbar({ open: true, message, severity: "success" });
//     handleDialogClose();
//     fetchVendors();
//   };

//   const handleToggleActive = async (vendor) => {
//     try {
//       if (vendor.isActive) {
//         await deactivateVendor(vendor.vendorId);
//         setSnackbar({
//           open: true,
//           message: `${vendor.vendorName} deactivated`,
//           severity: "success",
//         });
//       } else {
//         await reactivateVendor(vendor.vendorId);
//         setSnackbar({
//           open: true,
//           message: `${vendor.vendorName} reactivated`,
//           severity: "success",
//         });
//       }
//       fetchVendors();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.response?.data?.message || "Operation failed",
//         severity: "error",
//       });
//     }
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" mt={4}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box mt={4}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" gutterBottom>
//           Vendor Management ({vendors.length} vendors)
//         </Typography>
//         <Box>
//           <Button
//             variant="outlined"
//             onClick={fetchVendors}
//             size="small"
//             sx={{ mr: 1 }}
//           >
//             🔄 Refresh
//           </Button>
//           <Button
//             variant="contained"
//             onClick={openCreateDialog}
//             size="small"
//           >
//             + Add Vendor
//           </Button>
//         </Box>
//       </Box>

//       <TableContainer component={Paper}>
//         <Table size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell><strong>ID</strong></TableCell>
//               <TableCell><strong>Category</strong></TableCell>
//               <TableCell><strong>Name</strong></TableCell>
//               <TableCell><strong>Type</strong></TableCell>
//               <TableCell><strong>Contact Person</strong></TableCell>
//               <TableCell><strong>Phone</strong></TableCell>
//               <TableCell><strong>Email</strong></TableCell>
//               <TableCell><strong>Vehicle</strong></TableCell>
//               <TableCell><strong>Status</strong></TableCell>
//               <TableCell align="center"><strong>Actions</strong></TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {vendors.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={10} align="center">
//                   <Typography color="textSecondary" py={3}>
//                     No vendors yet. Click "+ Add Vendor" to create one.
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               vendors.map((vendor) => (
//                 <TableRow key={vendor.vendorId} hover>
//                   <TableCell>{vendor.vendorId}</TableCell>
//                   <TableCell>
//                     <Chip label={vendor.category} size="small" color="primary" variant="outlined" />
//                   </TableCell>
//                   <TableCell><strong>{vendor.vendorName}</strong></TableCell>
//                   <TableCell>
//                     <Chip label={vendor.vendorType} size="small" variant="outlined" />
//                   </TableCell>
//                   <TableCell>{vendor.contactPerson}</TableCell>
//                   <TableCell>{vendor.contactNumber}</TableCell>
//                   <TableCell>{vendor.email || "—"}</TableCell>
//                   <TableCell>{vendor.vehicleNumber || "—"}</TableCell>
//                   <TableCell>
//                     <Chip
//                       label={vendor.isActive ? "Active" : "Inactive"}
//                       color={vendor.isActive ? "success" : "default"}
//                       size="small"
//                     />
//                   </TableCell>
//                   <TableCell align="center">
//                     <Tooltip title="Edit vendor">
//                       <IconButton
//                         size="small"
//                         color="primary"
//                         onClick={() => openEditDialog(vendor)}
//                       >
//                         <EditIcon fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title={vendor.isActive ? "Deactivate" : "Reactivate"}>
//                       <IconButton
//                         size="small"
//                         color={vendor.isActive ? "error" : "success"}
//                         onClick={() => handleToggleActive(vendor)}
//                       >
//                         {vendor.isActive ? <BlockIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
//                       </IconButton>
//                     </Tooltip>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Create/Edit Vendor Dialog */}
//       <VendorDialog
//         open={dialogOpen}
//         onClose={handleDialogClose}
//         vendor={editingVendor}
//         onSaved={handleVendorSaved}
//       />

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//           variant="filled"
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default VendorRecords;

import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Box,
  Paper,
  TableContainer,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VerifiedIcon from "@mui/icons-material/Verified";
import BlockIcon from "@mui/icons-material/Block";
import PendingIcon from "@mui/icons-material/HourglassEmpty";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

import {
  getAllVendors,
  getVendorsByStatus,
  reactivateVendor,
} from "../../services/api";
import VendorDialog from "../../components/VendorDialog";
import VendorVerificationDialog from "../../components/VendorVerificationDialog";

const VendorRecords = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("ALL");

  const [vendorDialogOpen, setVendorDialogOpen] = useState(false);
  const [editingVendor, setEditingVendor] = useState(null);

  const [verificationDialogOpen, setVerificationDialogOpen] = useState(false);
  const [vendorToReview, setVendorToReview] = useState(null);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuVendor, setMenuVendor] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const res =
        filterStatus === "ALL"
          ? await getAllVendors()
          : await getVendorsByStatus(filterStatus);
      setVendors(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch vendors:", err);
      setSnackbar({
        open: true,
        message: "Failed to fetch vendors",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, [filterStatus]);

  const handleMenuOpen = (event, vendor) => {
    setMenuAnchor(event.currentTarget);
    setMenuVendor(vendor);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuVendor(null);
  };

  const openCreateDialog = () => {
    setEditingVendor(null);
    setVendorDialogOpen(true);
  };

  const openEditDialog = (vendor) => {
    setEditingVendor(vendor);
    setVendorDialogOpen(true);
    handleMenuClose();
  };

  const openVerificationDialog = (vendor) => {
    setVendorToReview(vendor);
    setVerificationDialogOpen(true);
    handleMenuClose();
  };

  const handleVendorSaved = (message) => {
    setSnackbar({ open: true, message, severity: "success" });
    setVendorDialogOpen(false);
    setEditingVendor(null);
    fetchVendors();
  };

  const handleVerificationDone = (message) => {
    setSnackbar({ open: true, message, severity: "success" });
    setVerificationDialogOpen(false);
    setVendorToReview(null);
    fetchVendors();
  };

  const handleReactivate = async (vendor) => {
    handleMenuClose();
    try {
      await reactivateVendor(vendor.vendorId);
      setSnackbar({
        open: true,
        message: "Vendor reactivated",
        severity: "success",
      });
      fetchVendors();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.message || "Failed to reactivate",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Status counts
  const counts = {
    all: vendors.length,
    pending: vendors.filter((v) => v.verificationStatus === "PENDING").length,
    verified: vendors.filter((v) => v.verificationStatus === "VERIFIED").length,
    rejected: vendors.filter((v) => v.verificationStatus === "REJECTED").length,
  };

  const getVerificationChip = (vendor) => {
    switch (vendor.verificationStatus) {
      case "VERIFIED":
        return (
          <Chip
            icon={<VerifiedIcon />}
            label="Verified"
            color="success"
            size="small"
            sx={{ fontWeight: 600 }}
          />
        );
      case "REJECTED":
        return (
          <Tooltip title={vendor.rejectionReason || "Rejected"}>
            <Chip
              icon={<BlockIcon />}
              label="Rejected"
              color="error"
              size="small"
              sx={{ fontWeight: 600 }}
            />
          </Tooltip>
        );
      case "PENDING":
      default:
        return (
          <Chip
            icon={<PendingIcon />}
            label="Pending Review"
            color="warning"
            size="small"
            sx={{ fontWeight: 600 }}
          />
        );
    }
  };

  const getActiveChip = (isActive) =>
    isActive ? (
      <Chip label="Active" color="success" size="small" variant="outlined" />
    ) : (
      <Chip label="Inactive" color="default" size="small" variant="outlined" />
    );

  const headerCellSx = {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: "text.primary",
    py: 1.5,
    bgcolor: "#f8f9fa",
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box mt={2}>
      {/* Stats cards */}
      <Stack direction="row" spacing={2} mb={3} flexWrap="wrap">
        <Paper
          elevation={0}
          sx={{
            p: 2,
            flex: 1,
            minWidth: 150,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Total Vendors
          </Typography>
          <Typography variant="h5" fontWeight="bold">
            {counts.all}
          </Typography>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            flex: 1,
            minWidth: 150,
            border: "1px solid",
            borderColor: "warning.light",
            bgcolor: "warning.50",
          }}
        >
          <Typography variant="caption" color="warning.dark">
            Pending Review
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="warning.dark">
            {counts.pending}
          </Typography>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            flex: 1,
            minWidth: 150,
            border: "1px solid",
            borderColor: "success.light",
            bgcolor: "success.50",
          }}
        >
          <Typography variant="caption" color="success.dark">
            Verified
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="success.dark">
            {counts.verified}
          </Typography>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            flex: 1,
            minWidth: 150,
            border: "1px solid",
            borderColor: "error.light",
            bgcolor: "error.50",
          }}
        >
          <Typography variant="caption" color="error.dark">
            Rejected
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="error.dark">
            {counts.rejected}
          </Typography>
        </Paper>
      </Stack>

      {/* Header with filter + actions */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
        mb={2}
      >
        <Typography variant="h6" fontWeight="bold">
          Vendor Management
        </Typography>

        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
          <ToggleButtonGroup
            value={filterStatus}
            exclusive
            onChange={(e, val) => val && setFilterStatus(val)}
            size="small"
          >
            <ToggleButton value="ALL" sx={{ px: 2 }}>
              All
            </ToggleButton>
            <ToggleButton value="PENDING" sx={{ px: 2 }}>
              Pending
            </ToggleButton>
            <ToggleButton value="VERIFIED" sx={{ px: 2 }}>
              Verified
            </ToggleButton>
            <ToggleButton value="REJECTED" sx={{ px: 2 }}>
              Rejected
            </ToggleButton>
          </ToggleButtonGroup>

          <Button
            variant="outlined"
            onClick={fetchVendors}
            size="small"
            startIcon={<RefreshIcon />}
          >
            Refresh
          </Button>

          <Button
            variant="contained"
            onClick={openCreateDialog}
            size="small"
            startIcon={<AddIcon />}
          >
            Add Vendor
          </Button>
        </Stack>
      </Box>

      {/* Vendors table */}
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>Vendor ID</TableCell>
              <TableCell sx={headerCellSx}>Vendor Info</TableCell>
              <TableCell sx={headerCellSx}>Type</TableCell>
              <TableCell sx={headerCellSx}>Contact</TableCell>
              <TableCell sx={headerCellSx}>Verification</TableCell>
              <TableCell sx={headerCellSx}>Active Status</TableCell>
              <TableCell align="center" sx={headerCellSx}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vendors.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                  <Typography color="text.secondary">
                    No vendors found
                    {filterStatus !== "ALL" && ` with status ${filterStatus}`}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              vendors.map((vendor) => (
                <TableRow
                  key={vendor.vendorId}
                  hover
                  sx={{
                    "&:last-child td": { borderBottom: 0 },
                    "& td": { py: 2 },
                  }}
                >
                  {/* ID */}
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold" color="primary">
                      #{vendor.vendorId}
                    </Typography>
                  </TableCell>

                  {/* Vendor info */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1.5}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 2,
                          bgcolor: "primary.50",
                          color: "primary.main",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <StorefrontIcon fontSize="small" />
                      </Box>
                      <Box>
                        <Typography variant="body2" fontWeight={600}>
                          {vendor.vendorName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {vendor.contactPerson}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  {/* Type */}
                  <TableCell>
                    <Chip
                      label={vendor.vendorType}
                      size="small"
                      variant="outlined"
                      sx={{ fontWeight: 500 }}
                    />
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                      mt={0.5}
                    >
                      {vendor.category}
                    </Typography>
                  </TableCell>

                  {/* Contact */}
                  <TableCell>
                    <Stack spacing={0.5}>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <PhoneIcon
                          sx={{ fontSize: 12, color: "text.secondary" }}
                        />
                        <Typography variant="caption">
                          {vendor.contactNumber}
                        </Typography>
                      </Box>
                      {vendor.email && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <EmailIcon
                            sx={{ fontSize: 12, color: "text.secondary" }}
                          />
                          <Typography variant="caption">
                            {vendor.email}
                          </Typography>
                        </Box>
                      )}
                    </Stack>
                  </TableCell>

                  {/* Verification */}
                  <TableCell>{getVerificationChip(vendor)}</TableCell>

                  {/* Active */}
                  <TableCell>{getActiveChip(vendor.isActive)}</TableCell>

                  {/* Actions */}
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={(e) => handleMenuOpen(e, vendor)}
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "&:hover": { bgcolor: "primary.50" },
                      }}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Action menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        PaperProps={{ elevation: 3, sx: { minWidth: 240, mt: 1 } }}
      >
        <MenuItem onClick={() => openVerificationDialog(menuVendor)}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Review & Verify"
            secondary="View documents and approve/reject"
            secondaryTypographyProps={{ fontSize: "0.7rem" }}
          />
        </MenuItem>

        <MenuItem onClick={() => openEditDialog(menuVendor)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Edit Details"
            secondary="Update vendor information"
            secondaryTypographyProps={{ fontSize: "0.7rem" }}
          />
        </MenuItem>

        {menuVendor &&
          !menuVendor.isActive &&
          menuVendor.verificationStatus === "VERIFIED" && (
            <MenuItem onClick={() => handleReactivate(menuVendor)}>
              <ListItemIcon>
                <PowerSettingsNewIcon fontSize="small" color="success" />
              </ListItemIcon>
              <ListItemText
                primary="Reactivate"
                secondary="Make vendor active again"
                secondaryTypographyProps={{ fontSize: "0.7rem" }}
              />
            </MenuItem>
          )}
      </Menu>

      {/* Vendor create/edit dialog */}
      <VendorDialog
        open={vendorDialogOpen}
        onClose={() => {
          setVendorDialogOpen(false);
          setEditingVendor(null);
        }}
        vendor={editingVendor}
        onSaved={handleVendorSaved}
      />

      {/* Verification dialog */}
      <VendorVerificationDialog
        open={verificationDialogOpen}
        onClose={() => {
          setVerificationDialogOpen(false);
          setVendorToReview(null);
        }}
        vendor={vendorToReview}
        onDone={handleVerificationDone}
      />

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VendorRecords;